import { useCallback } from 'react';
import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { Button } from '@/components/ui/button';
import { SubscriberDataEvent, useAnalytics } from '@/tracking/analytics';
import { IResortPathInfo } from '@/api/resort/types';

interface IProps {
  url?: string | null,
  resort?: IResortPathInfo,
}

const ToExternalPurchasePageButton = ({ url, resort }: IProps) => {
  const { t } = useOTSTranslation('common');
  const analitic = useAnalytics();

  const onClick = useCallback(() => {
    if (url) {
      analitic.subcriberEvent(SubscriberDataEvent.LiftAccessNavigation, { url, resort });
    }
  }, [analitic, url]);

  if (!url) {
    return null;
  }

  // Translated labels vary a lot in length ("ACHETEZ EN LIGNE" vs "BUY ONLINE"),
  // so the width follows the text (w-fit) with 120px as a floor, rather than being
  // pinned at 120px — a hard width made the longer labels run into the edges.
  // w-fit also stops the button stretching when it is a column flex item.
  return (
    <Button
      asChild
      className="h-7 w-fit min-w-[120px] px-3 text-xs uppercase no-underline hover:no-underline"
    >
      <a href={url} target="_blank" rel="noreferrer" onClick={onClick}>
        <span>{t('common.purchase')}</span>
      </a>
    </Button>
  );
};

export default ToExternalPurchasePageButton;
